module.exports = __webpack_public_path__ + "img/tarj-3.1110511b.svg";